module.exports = __webpack_public_path__ + "img/utr_id_images.eeeaea7.svg";